import { createFileRoute } from "@tanstack/react-router";
import { SalesPage } from "@/components/sales/sales-page";

export const Route = createFileRoute("/_app/sales")({
  component: SalesPage,
});
